export const deleteItemByIdCfn = <T extends { id: string; cleanup?: () => void}>(parent: Array<T>, id: string): boolean => {
	let removed = false;
	parent.forEach((b, i) => {
		if (b.id === id) {
			parent.splice(i, 1);
			b.cleanup();
			removed = true;
		}
	});

	return removed;
};
